import React from 'react';
import { Box, Paper, Table, TableBody, TableContainer, TableRow } from '@mui/material';
import { LocalizedTableCell as TableCell, LocalizedTooltip as Tooltip } from '../i18n/LocalizedMui';
import Typography from '../i18n/LocalizedTypography';

interface OverviewStat {
  label: string;
  value: number;
  detail?: React.ReactNode;
}

export default function AdminOverviewStats({ stats }: { stats: OverviewStat[] }) {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mb: 2, boxShadow: 'none' }}>
      <Table size="small" aria-label="Admin statistics" sx={{ tableLayout: 'fixed', minWidth: 760 }}>
        <TableBody>
          {Array.from({ length: Math.ceil(stats.length / 4) }, (_, row) => (
            <TableRow key={row} sx={{ '&:last-child td': { borderBottom: 0 } }}>
              {Array.from({ length: 4 }, (_, column) => {
                const stat = stats[row * 4 + column];
                return <TableCell key={column} sx={{ width: '25%', px: 1.25, py: 0.75, verticalAlign: 'middle', borderRight: column < 3 ? 1 : 0, borderColor: 'divider' }}>
                  {stat && <Tooltip title={stat.detail || ''} describeChild>
                    <Box tabIndex={stat.detail ? 0 : undefined} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                      <Typography variant="body2" sx={{ fontSize: '0.75rem', lineHeight: 1.35, textAlign: 'start', overflowWrap: 'anywhere' }}>{stat.label}</Typography>
                      <Typography component="span" sx={{ fontSize: '1rem', fontWeight: 700, lineHeight: 1.4, fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>{stat.value}</Typography>
                    </Box>
                  </Tooltip>}
                </TableCell>;
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
